import { getCookie } from 'util/cookie-util';

const getCustomerCurrency = (): string | undefined => getCookie('cart_currency');

export default getCustomerCurrency;
